import type { SupplementalSectionProps } from '../../../../../ApplicationEdit/Sections/7Supplemental/supplementalSections';
import { hasContactDetails } from '../../../../../../utils/capps-mappers';
import { ContactOverview } from './ContactOverview';

export function PersonalReferencesOverview({ answers }: SupplementalSectionProps) {
  const references = (answers.personalReferences ?? []).filter(hasContactDetails);

  return (
    <>
      {references.map((reference, index) => (
        <ContactOverview key={index} title={`Reference #${index + 1}`} contact={reference} hasRelationship hasNotes />
      ))}
    </>
  );
}
